import React, { useContext, useState, useEffect } from "react";
import useMousePosition from "../../hooks/useMousePosition";
import { CursorContext } from "../../CursorContextProvider";
import isTouchDevice from "../../utilities/isTouchDevice";

const Cursor = () => {
  const { clientX, clientY } = useMousePosition();
  const [cursor] = useContext(CursorContext);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleMouseEnter = () => setIsVisible(true);
    const handleMouseLeave = () => setIsVisible(false);
    document.body.addEventListener("mouseenter", handleMouseEnter);
    document.body.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      document.body.removeEventListener("mouseenter", handleMouseEnter);
      document.body.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);
  if (isTouchDevice) {
    return null;
  } else {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          pointerEvents: "none",
        }}
      >
        <svg
          width={50}
          height={50}
          viewBox="0 0 50 50"
          style={{
            position: "absolute",
            left: clientX,
            top: clientY,
            transform: `translate(-50%, -50%) scale(${
              cursor.active ? 2.5 : 1
            })`,
            stroke: cursor.active ? "black" : "white",
            strokeWidth: 1,
            fill: cursor.active ? "rgba(255,255,255,.5)" : "black",
            transition: "transform .2s ease-in-out",
            opacity: isVisible && clientX > 1 ? 1 : 0,
          }}
        >
          <circle cx="25" cy="25" r="8" />
        </svg>
      </div>
    );
  }
};

export default Cursor;
